
























































import {Component, Vue} from 'vue-property-decorator';
import DirectionSwitch from '@/layouts/back-office/misc/DirectionSwitch.vue';
import MessageCategoryIsDone from '@/layouts/gripper/components/MessageCategoryIsDone.vue';
import {Color, Option} from '@/types/gripper';
import {colorArray} from '@/plugins/Color';
import TaskElaboration from '@/layouts/gripper/components/TaskElaboration.vue';
import QuickLabelling from '@/layouts/gripper/QuickLabelling.vue';
import CanvasSegmentationContiniousMode from '@/layouts/gripper/segmentation/CanvasSegmentationContiniousMode.vue';
import CanvasSegmentationPointMode from '@/layouts/gripper/segmentation/CanvasSegmentationPointMode.vue';
import {
  JobInfo,
  JobInfo_job_options,
  JobInfo_job_task_parameter,
} from '@/types/intrador';
import PaginateButtonsShrinkingBin from '@/layouts/gripper/components/QuickLabeling/PaginateButtonsShrinkingBin.vue';
import IntradorLoader from '@/layouts/gripper/components/QuickLabeling/IntradorLoader.vue';
import SingleLabelling from '@/layouts/gripper/SingleLabelling.vue';

@Component({
  components: {
    SingleLabelling,
    IntradorLoader,
    CanvasSegmentationContiniousMode,
    CanvasSegmentationPointMode,
    TaskElaboration,
    PaginateButtonsShrinkingBin,
    MessageCategoryIsDone,
    DirectionSwitch,
    QuickLabelling,
  },
})
export default class JobInformation extends Vue {

  private jobInfo: JobInfo | null = null;
  private options: Option[] = [];
  private selectedParameterOption: Option | null = null;
  private parameter: JobInfo_job_task_parameter | null = null;

  private labelModes = [
    {
      options: ['Continuous Labeling', 'Point Labeling'],
      selectedOption: 'Continuous Labeling',
    },
  ];

  get queryVariables() {
    return {
      jobID: this.$route.params.jobID,
    };
  }

  private resolveData(data: JobInfo) {
    this.jobInfo = data;
    this.parameter = data.job!.task!.parameter;
    this.options = this.allPossibleOptions(data);

    this.setDefaultLabel();

    localStorage.setItem('job_id', this.jobInfo.job.id);
    localStorage.setItem('parameter_id', this.parameter.id);
    if (this.selectedParameterOption !== null) {
      localStorage.setItem('option_id', this.selectedParameterOption.id);
    }

    return data;
  }

  private allPossibleOptions(data: JobInfo): Option[] {
    if (!data.job || !data.job.task || !data.job!.task!.parameter) {
      return [];
    }

    const optionsList: Option[] = [];
    // default scenario
    if (data.job.options) {
      data.job.options.forEach((item: JobInfo_job_options, index: number) => {
        const option: Option = {
          id: item.id,
          value: item.value,
          color: this.getRandomColorStyle(index),
        };
        optionsList.push(option);
      });
    }

    return optionsList.reverse();
  }

  // get the default label (first label in the list)
  private setDefaultLabel() {
    if (!this.selectedParameterOption && this.allPossibleOptions.length > 0) {
      this.selectedParameterOption = this.options[0];
    }
  }

  private getRandomColorStyle(index: number): Color {
    const colorString = (colorArray[index]);
    return {backgroundColor: colorString} as Color;
  }

  private goToNewLabelCategory(option: Option) {
    this.selectedParameterOption = option;

    localStorage.setItem('option_id', this.selectedParameterOption.id);
  }


}
